/**
 * Traducción de los errores que devuelve el rodeo por Google o Apple.
 *
 * Vive aparte del componente porque el mensaje lo pinta la pantalla de acceso y el botón lo
 * pinta otro componente: un fichero que exporta a la vez un componente y una función rompe el
 * refresco en caliente de Vite.
 *
 * La API redirige con el **código** del error, no con el texto. Así el motivo no acaba escrito
 * en la barra de direcciones, en el historial ni en los registros del servidor, y el idioma lo
 * decide la SPA, que es quien sabe en cuál está la pantalla.
 */
const MESSAGES: Record<string, string> = {
  'auth.external_failed':
    'No hemos podido completar el acceso con ese proveedor. Inténtalo de nuevo.',
  'auth.external_no_subject': 'El proveedor no ha devuelto una identidad válida.',
  'auth.external_no_email':
    'Tu proveedor no ha compartido un correo, y sin él no podemos crear la cuenta. Prueba con email y contraseña.',
  'auth.external_email_unverified':
    'Ya hay una cuenta con ese correo y el proveedor no lo ha verificado. Entra con tu contraseña y enlaza la cuenta desde tu perfil.',
  'auth.provider_unknown': 'Ese proveedor no está disponible.',
  'account.email_taken': 'Ya existe una cuenta con ese email.',
  // Entra ID de las organizaciones (ADR-014).
  'auth.org_tenant_not_allowed':
    'Tu empresa no tiene acceso a la academia con su cuenta corporativa. Habla con tu responsable de formación.',
  'auth.org_not_member':
    'Tu cuenta ya no pertenece a esta organización. Habla con tu responsable de formación.',
  'auth.org_no_username': 'Tu cuenta de empresa no ha compartido tu usuario.',
  'auth.org_domain_mismatch':
    'Tu usuario de empresa no es de un dominio dado de alta para tu organización.',
  'auth.org_other_member': 'Tu cuenta pertenece a otra organización. Escribe a soporte para moverla.',
  'auth.org_not_provisioned':
    'Aún no te han dado de alta en la academia. Pídeselo a tu responsable de formación.',
  'auth.org_member_suspended':
    'Tu acceso a la academia está suspendido. Habla con tu responsable de formación.',
  'auth.org_identity_conflict':
    'Tu cuenta ya está vinculada a otra cuenta de empresa. Escribe a soporte.',
  'auth.org_inactive':
    'El acceso de tu empresa a la academia no está activo. Habla con tu responsable de formación.',
};

export function externalErrorMessage(code: string | null): string | null {
  if (!code) {
    return null;
  }

  return MESSAGES[code] ?? 'No hemos podido completar el acceso con ese proveedor.';
}
